import { useRef, useState } from 'react';

import authFetch from '../../../utils/authFetch';
import {
  applyNormaPrefillGroups,
  getNormaPrefillPlaceholderStorageKeys,
  prepareBlocksForNormaPrefill,
} from './model/normaPrefill';

/**
 * Управляет полным пользовательским сценарием предзаполнения по «Норме»:
 * очищает предыдущее описание, загружает заготовки и применяет их к блокам.
 *
 * Очистка намеренно выполняется до запроса. При ошибке старое описание не
 * восстанавливается. Повторный запуск блокируется до завершения операции.
 */
export const useNormaPrefill = ({
  apiUrl,
  blocks,
  processPlaceholders,
  setBlocks,
  templateId,
}) => {
  const [isNormaPrefilling, setIsNormaPrefilling] = useState(false);
  const normaPrefillInProgressRef = useRef(false);

  const startNormaPrefill = () => {
    if (normaPrefillInProgressRef.current) return;

    normaPrefillInProgressRef.current = true;
    setIsNormaPrefilling(true);

    getNormaPrefillPlaceholderStorageKeys(blocks, templateId).forEach(key => {
      localStorage.removeItem(key);
    });

    setBlocks(previousBlocks =>
      prepareBlocksForNormaPrefill(previousBlocks)
    );

    // Сохраняем существующий порядок: React сначала применяет разрушительную
    // очистку, после чего начинается загрузка значений «Нормы».
    setTimeout(async () => {
      try {
        const response = await authFetch(
          `${apiUrl}/groups-normal/?smart_template_name=${templateId}`
        );
        const groups = await response.json();

        setBlocks(previousBlocks =>
          applyNormaPrefillGroups({
            blocks: previousBlocks,
            groups,
            templateId,
            processPlaceholders,
          })
        );
      } catch (error) {
        alert('Ошибка при применении нормы');
        console.error(error);
      } finally {
        normaPrefillInProgressRef.current = false;
        setIsNormaPrefilling(false);
      }
    }, 0);
  };

  return {
    isNormaPrefilling,
    startNormaPrefill,
  };
};
